<template>
    <div class="personalities-card">
        <v-container class="ma-0 pa-0 mt-10">
            <v-row>
                <v-col cols="3">
                    <img
                    class="personalities-card-img" 
                    :src="profile_pic_src"
                    width="250"
                    height="250">
                </v-col>
                <v-col cols="9">
                    <v-container class=" ml-10 ma-0 pa-0">
                        <v-row>
                            <v-col class="text-left" cols="12">
                                <div class="personalities-card-fio">
                                    {{ surname + " " + name + " " + patronymic }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-5">
                            <v-col class="text-left">
                                <div class="personalities-card-label">
                                    Должность в РАИИ
                                </div>
                                <div class="personalities-card-text">
                                    {{ job_title }}
                                </div>
                            </v-col>
                            <v-col class="text-left">
                                <div class="personalities-card-label">
                                    Почта
                                </div>
                                <div class="personalities-card-text">
                                    {{ email }}
                                </div>
                            </v-col>
                            <v-col class="text-left">
                                <div class="personalities-card-label">
                                    Региональное отделение
                                </div>
                                <div class="personalities-card-text">
                                    {{ regional_office }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-4"/>
                        <v-row>
                            <v-col class="text-left mt-5">
                                <div class="personalities-card-label">
                                    Основное место работы
                                </div>
                                <div class="personalities-card-text">
                                    {{ main_workplace }}
                                </div>
                            </v-col>
                            <v-col class="text-left mt-5">
                                <div class="personalities-card-label">
                                    Должность
                                </div>
                                <div class="personalities-card-text">
                                    {{ job_title_of_main_workplace }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </div>
    <div class="personalities-edit" v-if="can_edit_personality">
      <v-container class="ma-0 pa-0 mt-10" fluid>
        <v-row>
            <v-col cols=6>
                <v-text-field
                    class="mr-4"
                    label="Фамилия"
                    v-model="surname">
                </v-text-field>
            </v-col>
            <v-col cols=6>
                <v-text-field
                    class="ml-4"
                    label="Имя"
                    v-model="name">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=6>
                <v-text-field
                    class="mr-4"
                    label="Отчество"
                    v-model="patronymic">
                </v-text-field>
            </v-col>
            <v-col cols=6>
                <v-text-field
                    class="ml-4"
                    label="Должность в РАИИ"
                    v-model="job_title">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=6>
                <v-text-field
                    class="mr-4"
                    label="Региональное отделение"
                    v-model="regional_office">
                </v-text-field>
            </v-col>
            <v-col cols=6>
                <v-text-field
                    class="ml-4"
                    label="Основное место работы"
                    v-model="main_workplace">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=6>
                <v-text-field
                    class="mr-4"
                    label="Должность на месте работы"
                    v-model="job_title_of_main_workplace">
                </v-text-field>
            </v-col>
            <v-col cols =6>
                <v-file-input
                    label="Изображение пользователя"
                    v-model="profile_pic"
                    :multiple="false"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=6>
                <v-select
                    label="Регионы"
                    variant="outlined"
                    v-model="region_id"
                    :items="regions"
                    item-title= "name"
                    item-value= "id"
                    hide-details
                />
            </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
import { useUserStore } from '@/store/user';
import { useAuthStore } from '@/store/auth';
import { useRegionStore } from '@/store/region';
import { computed } from 'vue'

export default {

    async mounted(){
        let regionStore = useRegionStore()
        await regionStore.getRegions()
    },

    setup() {
        let UserStore = useUserStore()
        let AuthStore = useAuthStore()
        let regionStore = useRegionStore()

        const regions =computed(
            () => {
                return regionStore.get_regions_personality
            }
        )

        const name = computed({
            get(){
                if (UserStore.changeUser.name)
                    return UserStore.changeUser.name
                return ''
            },
            set(newValue){
                UserStore.changeUser.name = newValue
            }   
        })

        const profile_pic = computed({
            get(){
                if (UserStore.changeUser.profile_pic){
                    if (UserStore.changeUser.profile_pic.fileName) {
                        return {'name': UserStore.changeUser.profile_pic.fileName}
                    }
                    else {
                        return {'name': UserStore.changeUser.profile_pic}
                    }
                }
                return null
            },
            set(newFile){
                if (!newFile){
                    UserStore.changeUser.profile_pic = null
                    return
                }
                const reader = new FileReader();
                reader.readAsDataURL(newFile);
                reader.onload = () => {
                    let base64 = reader.result.split(',')[1];
                    let value = {
                        'base64': base64,
                        'fileName': newFile.name
                    }
                    UserStore.changeUser.profile_pic = value
                }
            }
        })

        const profile_pic_src = computed(()=>{
            let profile_pic = UserStore.changeUser.profile_pic
            let str_src = 'data:image/'

            if (profile_pic){
                if (profile_pic.base64 && profile_pic.fileName){
                    let dot_index = profile_pic.fileName.lastIndexOf('.')
                    if (dot_index != -1){
                        str_src += profile_pic.fileName.substring(dot_index)
                        str_src += ';base64, ' + profile_pic.base64
                        return str_src
                    }
                }else{
                    return document.location.origin + '/' + profile_pic
                }
            }
            return null
        })

        const surname = computed({
            get(){
                if (UserStore.changeUser.surname)
                    return UserStore.changeUser.surname
                return ''
            },
            set(newValue){
                UserStore.changeUser.surname = newValue
            }   
        })

        const patronymic = computed({
            get(){
                if (UserStore.changeUser.patronymic)
                    return UserStore.changeUser.patronymic
                return ''
            },
            set(newValue){
                UserStore.changeUser.patronymic = newValue
            }   
        })

        const job_title = computed({
            get(){
                if (UserStore.changeUser.job_title)
                    return UserStore.changeUser.job_title
                return ''
            },
            set(newValue){
                UserStore.changeUser.job_title = newValue
            }   
        })

        const email = computed(()=>{
            {   if (UserStore.changeUser.email)
                    return UserStore.changeUser.email
                return ''
            }
        })

        const regional_office = computed({
            get(){
                if (UserStore.changeUser.regional_office)
                    return UserStore.changeUser.regional_office
                return ''
            },
            set(newValue){
                UserStore.changeUser.regional_office = newValue
            }   
        })

        const main_workplace = computed({
            get(){
                if (UserStore.changeUser.main_workplace)
                    return UserStore.changeUser.main_workplace
                return ''
            },
            set(newValue){
                UserStore.changeUser.main_workplace = newValue
            }   
        })

        const job_title_of_main_workplace = computed({
            get(){
                if (UserStore.changeUser.job_title_of_main_workplace)
                    return UserStore.changeUser.job_title_of_main_workplace
                return ''
            },
            set(newValue){
                UserStore.changeUser.job_title_of_main_workplace = newValue
            }
        })

        const region_id = computed({
            get(){
                if (UserStore.changeUser.region_id)
                    return UserStore.changeUser.region_id
                return ''
            },
            set(newValue){
                UserStore.changeUser.region_id = newValue
            }   
        })

        const can_edit_personality = computed(()=>{
            {   return AuthStore.can_edit_personality}
        })
        return {
            name,
            profile_pic,
            profile_pic_src,
            surname,
            patronymic,
            email,
            job_title,
            regional_office,
            main_workplace,
            job_title_of_main_workplace,
            can_edit_personality,
            regions,
            region_id
        };
    }
}
</script>